(function (angular) {
  angular.module('acme.common.component.filterbar', []).component('acmeFilterbar', {
    templateUrl: 'common/components/filterbar/filterbar.component.tpl.html',
    controller: FilterbarController,
    require: {
      ngModelCtrl: 'ngModel',
    },
    bindings: {
      ngModel: '<',
      loading: '<',
      disabled: '<',
      label: '<',
      placeholder: '<',
      submit: '&',
    },
  });

  FilterbarController.$inject = ['$element'];

  var id = 0;

  function FilterbarController($element) {
    var ctrl = this;
    ctrl.id = 'acme-filterbar-' + ++id;

    ctrl.$onInit = function () {
      $element.addClass('acme-filterbar');
    };

    ctrl.ngModelChange = function () {
      ctrl.ngModelCtrl.$setViewValue(ctrl.ngModel);
    };
  }
})(window.angular);
